import classNames from 'classnames';
import moment from 'moment';
import React, { useMemo } from 'react';

import { ProgramExtensionStatusReason } from '@vestahealthcare/common/enums';
import {
  MemberProgramExtension,
  Patient,
  ProgramExtension,
  ProgramExtensionStatus,
} from '@vestahealthcare/common/models';
import {
  DATE_FORMAT,
  DATE_FORMAT_SHORT,
  EMPTY,
} from '@vestahealthcare/common/utils/constants';

type Props = {
  member?: Patient;
};

export const MemberProgramExtensionDetails = ({ member }: Props) => {
  const { programExtensions } = member ?? {};

  const sortedProgramExtensions = useMemo(
    () =>
      (
        programExtensions || ([] as MemberProgramExtension[])
      ).toSorted(({ programExtension: a }, { programExtension: b }) =>
        ProgramExtension.sort(a, b),
      ),
    [programExtensions],
  );

  if (!programExtensions?.length) return <>{EMPTY}</>;

  return (
    <>
      {sortedProgramExtensions.map((proExt, idx) => (
        <p
          className={classNames(
            'flex spaced',
            idx !== sortedProgramExtensions?.length - 1 && 'no-margin',
          )}
          key={proExt.programExtension.id}
        >
          <span>{proExt.programExtension.abbr}</span>{' '}
          {proExt.status &&
          proExt.status?.id === ProgramExtensionStatus.HOLD ? (
            <span className="size-xs">
              [
              {[
                proExt.status?.description,
                proExt.statusReason?.toString(),
                proExt.statusReason === ProgramExtensionStatusReason.OTHER
                  ? proExt.statusReasonOther
                  : undefined,
                proExt.releaseDate
                  ? moment(proExt.releaseDate, DATE_FORMAT).format(
                      DATE_FORMAT_SHORT,
                    )
                  : undefined,
                proExt.serviceProvider?.toString(),
              ]
                .filter(Boolean)
                .join(' - ')}
              ]
            </span>
          ) : (
            <span className="size-xs">
              [
              {[proExt.status?.description, proExt.serviceProvider?.toString()]
                .filter(Boolean)
                .join(' - ')}
              ]
            </span>
          )}
        </p>
      ))}
    </>
  );
};
